import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import dateStringFromDate from '@src/util/dateStringFromDate';
import Notification from './Notification';
import './styles.scss';

const NotificationGroup = ({ notifications, isLastGroup }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const isRead = notifications.some(({ readAt }) => !!readAt);

  return (
    <div
      className={classnames({
        'notification-group': true,
        'notification-group--last-item': isLastGroup,
        'notification-group--unread': !isRead,
      })}
    >
      <Notification notification={notifications[0]} />

      {notifications.length > 1 && (
        <p className="notification-group__collapse-button" onClick={() => setIsCollapsed(!isCollapsed)}>
          {isCollapsed ? `show ${notifications.length - 1} more` : `show ${notifications.length - 1} less`}
        </p>
      )}
      {notifications.length > 1 &&
        !isCollapsed &&
        notifications.slice(1).map(notification => {
          return <Notification key={notification.id} notification={notification} />;
        })}
      <p className="notification-group__timestamp">{dateStringFromDate(notifications[0].sentAt)}</p>
    </div>
  );
};

NotificationGroup.propTypes = {
  isLastGroup: PropTypes.bool.isRequired,
  notifications: PropTypes.arrayOf(
    PropTypes.shape({
      icons: PropTypes.shape({
        primary: PropTypes.shape({
          fullUrl: PropTypes.string,
          id: PropTypes.string,
        }).isRequired,
        secondary: PropTypes.shape({
          fullUrl: PropTypes.string,
          id: PropTypes.string,
        }),
      }),
      application: PropTypes.shape({
        opening: PropTypes.shape({
          recruiter: PropTypes.shape({
            id: PropTypes.string,
            nameInitials: PropTypes.string,
          }),
        }),
      }),
      id: PropTypes.string.isRequired,
      message: PropTypes.string.isRequired,
      opening: PropTypes.shape({
        recruiter: PropTypes.shape({
          id: PropTypes.string,
          nameInitials: PropTypes.string,
        }),
      }),
      readAt: PropTypes.string,
      sentAt: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      url: PropTypes.string,
    }),
  ).isRequired,
};

export default NotificationGroup;
